import Text from 'components/v4/Text';
import { MdFileCopy } from 'react-icons/md';
import { HStack, IconButton, Tooltip, Box } from '@chakra-ui/react';
import { iconStyling } from '../agGridStyles';
import useCellHover from '../hooks/useCellHover';

const CopyCellRenderer = ({
    value,
    valueFormatted,
    tooltip,
    leftAdornment,
}) => {
    const { isHovered, containerRef } = useCellHover();
    const formattedValue = valueFormatted ?? value;

    return (
        <HStack
            ref={containerRef}
            width="100%"
            sx={{
                position: 'relative',
                height: '100%',
            }}>
            {leftAdornment}
            <Tooltip label={tooltip}>
                <Box isTruncated>
                    <Text isTruncated>{formattedValue}</Text>
                </Box>
            </Tooltip>
            {isHovered && (
                <Tooltip label="Copy to clipboard">
                    <IconButton
                        sx={{
                            ...iconStyling,
                            pointerEvents: 'auto',
                        }}
                        size="sm"
                        variant="ghost"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(value);
                        }}>
                        <MdFileCopy />
                    </IconButton>
                </Tooltip>
            )}
        </HStack>
    );
};

export default CopyCellRenderer;
